import React from "react";
import StayTuneImg from "../images/staytuned.png";

function StayTune() {
  return (
    <div className="stay-tune-container">
      <img className="stay-tune" src={StayTuneImg} alt="stay-tune" />
    </div>
  );
}
export default StayTune;
